(function () {
  const QuickView = {
    modal: document.querySelector('[data-quickview-modal]'),
    body: document.querySelector('[data-quickview-body]'),

    init() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-quickview]');
        if (!btn) return;
        e.preventDefault();
        this.load(btn.dataset.quickview);
      });
    },

    load(handle) {
      if (!this.modal || !this.body) return;
      this.body.classList.add('is-loading');
      this.body.innerHTML = '<span class="loading-spinner"></span>';
      fetch(`/products/${handle}?section_id=main-product`)
        .then((res) => {
          if (!res.ok) throw new Error('load failed');
          return res.text();
        })
        .then((html) => {
          this.body.classList.remove('is-loading');
          this.body.innerHTML = html;
          const scriptTags = this.body.querySelectorAll('script');
          scriptTags.forEach((s) => {
            const clone = document.createElement('script');
            if (s.src) {
              clone.src = s.src;
            } else {
              clone.textContent = s.textContent;
            }
            s.replaceWith(clone);
          });
          if (window.ShopifyProductForm) {
            this.body.querySelectorAll('[data-product-form]').forEach((form) => {
              window.ShopifyProductForm.bind(form);
            });
          }
          if (window.Branzos) {
            window.Branzos.initQtySelectors();
            window.Branzos.initReveal();
          }
          Branzos.openDrawer(this.modal);
        })
        .catch(() => {
          this.body.classList.remove('is-loading');
          Branzos.showToast(window.ShopifyTheme.i18n.error, '😵');
        });
    },
  };

  window.ShopifyQuickView = QuickView;
  Branzos.onLoad(() => QuickView.init());
})();
